import { createSelector } from "reselect";
import { useSelector } from "react-redux";
export const useEmployeeNames = () => {
    const AllEmployees = useSelector((state) => state.employee.AllEmployees);
  
    const names = AllEmployees?.filter(emp => 
      emp.employeestatus === "Active" && 
      (emp.department === 'Operations' || emp.department === 'Both')
    ).map(emp => ({
      key: emp._id || `${emp.firstname}-${emp.lastname}`,
      label: `${emp.firstname} ${emp.lastname}`,
      value: `${emp.firstname} ${emp.lastname}`,
      firstname: emp.firstname,
      lastname: emp.lastname
    })) || [];
    
    return names;
    
  };    
  